<template>
  <div>
    <section v-if="showLoader" class="hero is-fullheight is-fullheight-with-navbar">
      <div class="hero-body">
        <div class="sk-cube-grid">
          <div class="sk-cube sk-cube1"></div>
          <div class="sk-cube sk-cube2"></div>
          <div class="sk-cube sk-cube3"></div>
          <div class="sk-cube sk-cube4"></div>
          <div class="sk-cube sk-cube5"></div>
          <div class="sk-cube sk-cube6"></div>
          <div class="sk-cube sk-cube7"></div>
          <div class="sk-cube sk-cube8"></div>
          <div class="sk-cube sk-cube9"></div>
        </div>
      </div>
    </section>
    <transition name="fade">
      <div v-if="!showLoader">
        <drop-page></drop-page>
        <navbar ></navbar>
        <about-page></about-page>
        <services-page></services-page>
        <latest-work-page></latest-work-page>
        <footer-contact></footer-contact>
      </div>
    </transition>
  </div>
</template>

<script>
import NavbarVue from '@/components/Navbar.vue'
import DropPageVue from '@/views/DropPage.vue'
import AboutPageVue from '@/views/AboutPage.vue'
import ServicesPageVue from '@/views/ServicesPage.vue'
import LatestWorkPageVue from '@/views/LatestWorkPage.vue'
import FooterVue from '@/components/Footer.vue'
import MobileNavVue from '@/components/MobileNav.vue'

export default {
  components: {
    navbar: NavbarVue,
    'drop-page': DropPageVue,
    'about-page': AboutPageVue,
    'services-page': ServicesPageVue,
    'latest-work-page': LatestWorkPageVue,
    'footer-contact': FooterVue,
  },

  data () {
    return {
      showLoader: false,
    }
  },
  created () {
    this.showLoader = true
  },
  mounted () {
    setTimeout(() => {
      this.showLoader = false
    }, 500)
  },
}
</script>

<style lang="scss" scoped>
.has-shadow {
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2),
    0 -3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14),
    0 -6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12),
    0 -1px 18px 0 rgba(0, 0, 0, 0.12);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.sk-cube-grid {
  width: 80px;
  height: 80px;
  margin: 100px auto;
}

.sk-cube-grid .sk-cube {
  width: 33%;
  height: 33%;
  background-color: #24a986;
  float: left;
  -webkit-animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
  animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
}
.sk-cube-grid .sk-cube1 {
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}
.sk-cube-grid .sk-cube2 {
  -webkit-animation-delay: 0.3s;
  animation-delay: 0.3s;
}
.sk-cube-grid .sk-cube3 {
  -webkit-animation-delay: 0.4s;
  animation-delay: 0.4s;
}
.sk-cube-grid .sk-cube4 {
  -webkit-animation-delay: 0.1s;
  animation-delay: 0.1s;
}
.sk-cube-grid .sk-cube5 {
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}
.sk-cube-grid .sk-cube6 {
  -webkit-animation-delay: 0.3s;
  animation-delay: 0.3s;
}
.sk-cube-grid .sk-cube7 {
  -webkit-animation-delay: 0s;
  animation-delay: 0s;
}
.sk-cube-grid .sk-cube8 {
  -webkit-animation-delay: 0.1s;
  animation-delay: 0.1s;
}
.sk-cube-grid .sk-cube9 {
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}

@keyframes sk-cubeGridScaleDelay {
  0%,
  70%,
  100% {
    -webkit-transform: scale3D(1, 1, 1);
    transform: scale3D(1, 1, 1);
  }
  35% {
    -webkit-transform: scale3D(0, 0, 1);
    transform: scale3D(0, 0, 1);
  }
}
</style>
